import { Location } from 'react-router';

type LocationStateWithListSearch<T> = {
  listSearchParams?: T;
};

export const getListSearchFromLocation = <T>(
  location: Location,
  buildSearch: (params: T | null | undefined) => string,
) => {
  if (location.search) return location.search;
  return buildSearch(
    (location.state as LocationStateWithListSearch<T> | undefined)
      ?.listSearchParams,
  );
};
